import { Briefcase, GraduationCap, Coins, BookOpen, Heart } from 'lucide-react';
import { Link } from 'react-router-dom';

const categories = [
  {
    id: 'emploi',
    title: 'Emplois',
    description: 'Offres d\'emploi CDI, CDD',
    icon: Briefcase,
    color: 'bg-primary',
    count: '150+'
  },
  {
    id: 'stage',
    title: 'Stages',
    description: 'Stages rémunérés et non rémunérés',
    icon: GraduationCap,
    color: 'bg-secondary',
    count: '80+'
  },
  {
    id: 'bourse',
    title: 'Bourses',
    description: 'Bourses d\'études locales et internationales',
    icon: Coins,
    color: 'bg-success',
    count: '45+'
  },
  {
    id: 'formation',
    title: 'Formations',
    description: 'Formations professionnelles certifiantes',
    icon: BookOpen,
    color: 'bg-accent',
    count: '120+'
  },
  {
    id: 'volontariat',
    title: 'Volontariat',
    description: 'Missions de volontariat et bénévolat',
    icon: Heart,
    color: 'bg-destructive',
    count: '30+'
  }
];

export function OpportunityCategories() {
  return (
    <section className="relative py-20 bg-gradient-to-b from-background to-primary/5 overflow-hidden">
      {/* Decorative Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-40">
        <div className="absolute top-20 left-10 w-72 h-72 bg-primary/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-primary/10 rounded-full blur-3xl animate-pulse animation-delay-200"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-4xl md:text-5xl font-poppins font-bold text-foreground mb-4">
            Explorez les Opportunités
          </h2>
          <p className="text-xl text-muted-foreground font-inter max-w-2xl mx-auto">
            Découvrez toutes les catégories d'opportunités disponibles pour booster votre carrière
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
          {categories.map((category, index) => {
            const Icon = category.icon;
            return (
              <Link
                key={category.id}
                to={`/opportunities?type=${category.id}`}
                className="group relative bg-card rounded-2xl p-6 border-2 border-border hover:border-primary transition-all duration-300 hover:-translate-y-2 hover:shadow-lg animate-fade-in"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Gradient overlay on hover */}
                <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                
                <div className="relative z-10">
                  <div className="relative mb-6">
                    <div className="relative w-20 h-20 rounded-2xl bg-gradient-to-br from-primary/20 via-primary/10 to-transparent flex items-center justify-center mb-4 group-hover:scale-110 group-hover:rotate-3 transition-all duration-300 shadow-md">
                      <div className="absolute inset-0 rounded-2xl bg-primary opacity-0 group-hover:opacity-10 blur transition-opacity"></div>
                      <Icon className="relative h-10 w-10 text-primary group-hover:scale-110 transition-transform duration-300" strokeWidth={2.5} />
                    </div>
                    <span className="absolute -top-2 -right-2 bg-primary text-primary-foreground px-3 py-1.5 rounded-full text-xs font-bold shadow-md group-hover:scale-110 transition-transform">
                      {category.count}
                    </span>
                  </div>
                  <h3 className="font-bold text-xl text-foreground mb-2 group-hover:text-primary transition-colors">
                    {category.title}
                  </h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {category.description}
                  </p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}